// @flow
import type {Action} from './action-types';
import * as types from './action-types';
import {filter} from 'lodash';

export type State = {
  step: Number,
  country: String,
  companyCode: String,
  costCentre: String,
  answers: Array<any>,
  questions: Array<any>,
  vehicles: Object,
  options: Array<any>,
  summary: Object,
  fetchingQuestions: boolean,
  fetchingVehicles: boolean,
  fetchingOptions: boolean,
  fetchingSummary: boolean,
  exportingQuote: boolean,
  submittingQuote: boolean,
  selectedVehicle: Object,
  selectedColour: Object,
  selectedExtras: Array<any>,
  selectedLeaseOptions: Array<any>,
  deliveryDetails: Object,
  fetchingAddresses: boolean,
  RegisterAddresses: Array<any>,
  estimatedCost:string,
  quoteId: string,
  leaseDetails: Object,
  submitSuccess: boolean
};

export const initialState: State = {
  step: 1,
  country: '',
  costcenter: '',
  restrictionCostCenter: '',
  questions: [],
  answers: [],
  vehicles: {
    Vehicles: []
  },
  options: [],
  fetchingQuestions: true,
  fetchingVehicles: true,
  fetchingVehiclesError: false,
  fetchingOptions: true,
  exportingQuote: false,
  submittingQuote: false,
  hasSubmitted: false,
  quoteUpdateSuccess: false,
  updatingQuote: false,
  selectedVehicle: {},
  selectedColour: {},
  selectedExtras: [],
  selectedLeaseOptions: [],
  deliveryDetails: {},
  DeliveryDate: '',
  fetchingAddresses: true,
  registerAddresses: [],
  fetchingSummary: true,
  summary: {
    Quote:{},
    Questions: []
  },
  estimatedCost:'',
  quoteId: '',
  leaseDetails: {},
  submitSuccess: false
};

const create = (state:State = initialState, action:Action):State => {
  switch (action.type) {

    /**
     * progress tracking
     */
    case types.UPDATE_STEP:
      return Object.assign({}, state, {
        step: action.step
      });


    /**
     * dynamic questions
     */

    /*************************Fetch Question action states START ***************************/
      case `${types.FETCH_QUESTIONS}_PENDING`:
        return Object.assign({}, state, {fetchingQuestions: true});

      case `${types.FETCH_QUESTIONS}_FULFILLED`:
        return Object.assign({}, state, {
          questions: action.payload,
          fetchingQuestions: false,
          serverError: false
        });

      case `${types.FETCH_QUESTIONS}_REJECTED`:
        return {
          isRejected: true,
          error: 'Fetch Question action Failed'
        };
    /*************************Fetch Question action states END ***************************/


    case types.SET_QUESTION_ANSWER:
    {
      const {id, value, name} = action;
      const answers = filter(state.answers, (o) => o.QuestionId !== id);

      return Object.assign({}, state, {
        answers: [...answers, {
          QuestionId: id,
          Answer: value,
          InputFieldName: name
        }]
      });
    }

    case types.CLEAR_QUESTION_ANSWERS:
      return initialState;

    /************************* Setting Source START ***************************/

    case types.SET_CQC_COUNTRY: {
      const { value } = action;
      return Object.assign({}, state, {
        country: value
      });
    }

    case types.SET_CQC_COSTCENTER: {
      const { value } = action;
      return Object.assign({}, state, {
        costcenter: value
      });
    }

    case types.SET_CQC_RESCOSTCENTER: {
      const { value } = action;
      return Object.assign({}, state, {
        restrictionCostCenter: value
      });
    }

    /************************* Setting Source END ***************************/

    /*********************** Fetch vehicles action states START ***************************/

    case `${types.FETCH_VEHICLES}_PENDING`:
    {
        const {
          answers,
          country,
          costcenter,
          restrictionCostCenter
        } = state;
        return Object.assign({}, initialState, {
          fetchingVehicles: true,
          answers,
          country,
          costcenter,
          restrictionCostCenter
        });
    }
    case `${types.FETCH_VEHICLES}_FULFILLED`:
        return Object.assign({}, state, {
        vehicles: action.payload.data,
        fetchingVehicles: false,
        serverError: false,
        fetchingVehiclesError: false
    });
    case `${types.FETCH_VEHICLES}_REJECTED`:
         return Object.assign({}, state, {
        fetchingVehiclesError: action.payload
      });
    /*********************** Fetch vehicles action states END ***************************/

    case types.SELECT_VEHICLE:
      return Object.assign({}, state, {
        selectedVehicle: action.vehicle,
        selectedTerms: action.terms
      });


    /**
     * options
     */
    /*************************Fetch options action states START ***************************/
      case `${types.FETCH_OPTIONS}_PENDING`:
       return Object.assign({}, state, {fetchingOptions: true});

      case `${types.FETCH_OPTIONS}_FULFILLED`:
        return Object.assign({}, state, {
        options: action.payload,
        fetchingOptions: false,
        serverError: false
      });

      case `${types.FETCH_OPTIONS}_REJECTED`:
        return {
          isRejected: true,
          error: 'Fetch options action Failed'
        };
    /*************************Fetch options action states END ***************************/


    case types.SELECT_COLOUR:
      return Object.assign({}, state, {
        selectedColour: action.selectedColour
      });

    case types.SELECT_EXTRA:
    {
      const {code, description} = action;
      const extras = state.selectedExtras;

      return Object.assign({}, state, {
        selectedExtras: [...extras, {
          code,
          description
        }]
      });
    }

    case types.DESELECT_EXTRA:
    {
      const {code} = action;
      const extras = state.selectedExtras;
      return Object.assign({}, state, {
        selectedExtras: [...extras.filter(ext => ext.code !== code)]
      });
    }


    /**
     * delivery details
     */
    case types.SET_DELIVERY_DETAILS:
    {
      const {
        DeliveryAddress,
        DeliveryState,
        DeliveryPostalCode,
        DeliverySuburb,
        CustomerContactPhone,
        CustomerName,
        DeliveryDate,
        ManualAddress
      } = action;
      return Object.assign({}, state, {
        deliveryDetails: {
          DeliveryAddress,
          DeliveryState,
          DeliveryPostalCode,
          DeliverySuburb,
          CustomerContactPhone,
          CustomerName,
          DeliveryDate,
          ManualAddress
        }
      });
    }

    //Addresses
    /*************************Fetch Addresses action states START ***************************/
      case `${types.FETCH_ADDRESSES}_PENDING`:
        return Object.assign({}, state, {fetchingAddresses: true});

      case `${types.FETCH_ADDRESSES}_FULFILLED`:
         return Object.assign({}, state, {
            registerAddresses: action.payload,
            fetchingAddresses: false,
            serverError: false
      });

      case `${types.FETCH_ADDRESSES}_REJECTED`:
        return {
          isRejected: true,
          error: 'Fetch Addresses action Failed'
        };
    /*************************Fetch Addresses action states END ***************************/


    /**
     * lease details
     */
    case types.SET_LEASE_DETAILS:
    {
      const {
        ReliefVehicleCode,
        RoadsideCode,
        AccidentManagementCode,
        InsuranceCode,
        RegistrationState,
        RegistrationPostalCode,
        TollServiceCode,
        FuelCardService,
        TyresIncludedCode,
        stateCache
      } = action;
      return Object.assign({}, state, {
        selectedLeaseOptions: [
          RoadsideCode,
          AccidentManagementCode,
          TollServiceCode,
          FuelCardService,
          ReliefVehicleCode,
          InsuranceCode,
          TyresIncludedCode
        ],
        leaseDetails: {
          ReliefVehicleCode,
          RoadsideCode,
          AccidentManagementCode,
          InsuranceCode,
          RegistrationState,
          RegistrationPostalCode,
          TollServiceCode,
          FuelCardService,
          TyresIncludedCode,
          stateCache
        }
      });
    }

    case types.SET_ESTIMATED_COST:
      return Object.assign({}, state, {
        estimatedCost: action.cost
      });

    case types.SET_QUOTE_ID:
      return Object.assign({}, state, {
        quoteId: action.id
      });

    /**
     * update quote
     */
    /*************************update Quote action states START ***************************/
      case `${types.UPDATE_QUOTE}_PENDING`:
        return Object.assign({}, state, {
        quoteUpdateSuccess: false,
        updatingQuote: true
      });
      case `${types.UPDATE_QUOTE}_FULFILLED`:
        return Object.assign({}, state, {
            updatingQuote: false,
            quoteUpdateSuccess: true
        });
      case `${types.UPDATE_QUOTE}_REJECTED`:
       return {
          isRejected: true,
          error: 'update Quote action  Failed'
        };
    /*************************update Quote action states END ***************************/


    /**
     * quote summary
     */
   /*************************Fetch quote summary action states START ***************************/
      case `${types.FETCH_QUOTE_SUMMARY}_PENDING`:
        return Object.assign({}, state, { fetchingSummary: true });

      case `${types.FETCH_QUOTE_SUMMARY}_FULFILLED`:
          return Object.assign({}, state, { fetchingSummary: false, summary:action.payload });

      case `${types.FETCH_QUOTE_SUMMARY}_REJECTED`:
        return {
          isRejected: true,
          error: 'Fetch quote summary action Failed'
        };
    /*************************Fetch quote summary action states END ***************************/



    /**
     * export quote
     */
     /*************************Export Quote action states START ***************************/
      case `${types.EXPORT_QUOTE}_PENDING`:
         return Object.assign({}, state, { exportingQuote: true });
      case `${types.EXPORT_QUOTE}_FULFILLED`:
          return Object.assign({}, state, { exportingQuote: false });
      case `${types.EXPORT_QUOTE}_REJECTED`:
        return Object.assign({}, state, { exportingQuote: false });
    /*************************Export Quote action states END ***************************/



    /**
     * submit quote
     */
    /*************************Submit Quote action states START ***************************/
      case `${types.SUBMIT_QUOTE}_PENDING`:
        return Object.assign({}, state, { submittingQuote: true });

      case `${types.SUBMIT_QUOTE}_FULFILLED`:
           {
                const { quoteId } = state;
                return Object.assign({}, initialState, {
                  hasSubmitted: true,
                  submitSuccess: action.payload.success,
                  quoteId
                });
            }

      case `${types.SUBMIT_QUOTE}_REJECTED`:
        return Object.assign({}, state, { submittingQuote: false });
    /*************************Submit Quote action states END ***************************/


    default:
      return state;
  }
};

export default create;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/reducer.js